import { api } from "@/lib/api";

export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
export const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
export const pushPermission = () => (pushSupported() ? Notification.permission : "unsupported");

function b64(v) {
  const pad = "=".repeat((4 - (v.length % 4)) % 4);
  const raw = atob((v + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export async function enablePush() {
  if (!pushSupported()) {
    throw new Error(isIOS() && !isStandalone()
      ? "على الآيفون: أضف التطبيق إلى الشاشة الرئيسية أولاً ثم افتحه منها"
      : "هذا الجهاز أو المتصفح لا يدعم التنبيهات");
  }
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("لم يتم السماح بالتنبيهات. يمكنك تفعيلها من إعدادات الهاتف");
  const reg = await navigator.serviceWorker.ready;
  const { data } = await api.get("/push/key");
  let sub = await reg.pushManager.getSubscription();
  if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64(data.key) });
  await api.post("/push/subscribe", sub.toJSON());
  return true;
}

export async function isSubscribed() {
  if (!pushSupported() || Notification.permission !== "granted") return false;
  const reg = await navigator.serviceWorker.getRegistration();
  return !!(reg && (await reg.pushManager.getSubscription()));
}
